var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("pleaseChoose")
                  },
                  on: { change: _vm.envIdChange },
                  model: {
                    value: _vm.paramsData.env_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "env_id", $$v)
                    },
                    expression: "paramsData.env_id"
                  }
                },
                _vm._l(_vm.szgmEnv, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("serverChannel")
                  },
                  on: { change: _vm.serverChange },
                  model: {
                    value: _vm.server_channel,
                    callback: function($$v) {
                      _vm.server_channel = $$v
                    },
                    expression: "server_channel"
                  }
                },
                _vm._l(_vm.serverChannel, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("showTestServer")
                  },
                  on: { change: _vm.serverChannelChange },
                  model: {
                    value: _vm.show_test,
                    callback: function($$v) {
                      _vm.show_test = $$v
                    },
                    expression: "show_test"
                  }
                },
                _vm._l(_vm.serverType, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    filterable: "",
                    placeholder: _vm.$t("server")
                  },
                  on: { change: _vm.severChange },
                  model: {
                    value: _vm.paramsData.server_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "server_id", $$v)
                    },
                    expression: "paramsData.server_id"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.selectAll },
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("selectAll")) + " ")]
                  ),
                  _vm._l(_vm.serverListYJ, function(item) {
                    return _c("el-option", {
                      key: item.serverID,
                      attrs: { label: item.serverName, value: item.serverID }
                    })
                  })
                ],
                2
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("playerId"), clearable: "" },
                model: {
                  value: _vm.paramsData.uid,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "uid", $$v)
                  },
                  expression: "paramsData.uid"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("playerName"), clearable: "" },
                model: {
                  value: _vm.paramsData.uname,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "uname", $$v)
                  },
                  expression: "paramsData.uname"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-date-picker", {
                attrs: {
                  "picker-options": _vm.pickerOptionsRadius,
                  "value-format": "timestamp",
                  type: "datetimerange",
                  "start-placeholder": _vm.$t("startTime"),
                  "end-placeholder": _vm.$t("endTime")
                },
                model: {
                  value: _vm.date,
                  callback: function($$v) {
                    _vm.date = $$v
                  },
                  expression: "date"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("punishmentStatus")
                  },
                  model: {
                    value: _vm.paramsData.status,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "status", $$v)
                    },
                    expression: "paramsData.status"
                  }
                },
                _vm._l(_vm.isAbnormakList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("reason"), clearable: "" },
                model: {
                  value: _vm.paramsData.reason,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "reason", $$v)
                  },
                  expression: "paramsData.reason"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("search")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.tableData.length
        ? _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.exportdataDealoading
                      },
                      on: { click: _vm.exportdata }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("export")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.tableData.length
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.reqLoading,
                  expression: "reqLoading"
                }
              ],
              attrs: { data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "uid", label: _vm.$t("playerId"), width: "140" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c(
                            "div",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  return _vm.goToUserDetail(row.uid)
                                }
                              }
                            },
                            [_vm._v(_vm._s(row.uid))]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1088790165
                )
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "uname",
                  label: _vm.$t("playerName"),
                  width: "200"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "recharge_amount",
                  label: _vm.$t("totalRechargeAmount"),
                  width: "160"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _vm._v(
                            " " +
                              _vm._s((row.recharge_amount / 100).toFixed(2)) +
                              " "
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2457107950
                )
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "uname",
                  label: _vm.$t("registerTime"),
                  width: "200"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  row.register
                                    ? row.register.register_time
                                      ? row.register.register_time
                                      : "/"
                                    : "/"
                                ) +
                                " "
                            )
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  627173178
                )
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "time",
                  label: _vm.$t("violationTime"),
                  width: "200"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [_vm._v(" " + _vm._s(row.time) + " ")]
                      }
                    }
                  ],
                  null,
                  false,
                  826152298
                )
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "reason",
                  label: _vm.$t("violationReason"),
                  "show-overflow-tooltip": "",
                  width: "400"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "text-ellipsis-1" }, [
                            _vm._v(_vm._s(row.reason))
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  569602408
                )
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: _vm.$t("status"),
                  width: "280"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          row.status == 1
                            ? _c("div", [_vm._v(_vm._s(_vm.$t("notPunished")))])
                            : _vm._e(),
                          row.status == 2
                            ? _c("div", { staticStyle: { color: "red" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("banned")) +
                                    " - " +
                                    _vm._s(row.expire_time)
                                )
                              ])
                            : _vm._e(),
                          row.status == 3
                            ? _c(
                                "div",
                                { staticStyle: { color: "goldenrod" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("banEnded")) +
                                      " - " +
                                      _vm._s(row.expire_time)
                                  )
                                ]
                              )
                            : _vm._e(),
                          row.status == 4
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("unbanned")) +
                                    " - " +
                                    _vm._s(row.expire_time)
                                )
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4245296543
                )
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "reason",
                  label: _vm.$t("operationBanRecord"),
                  width: "400"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          row.ban_state.length
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        placement: "top-start"
                                      }
                                    },
                                    [
                                      _c("div", {
                                        attrs: { slot: "content" },
                                        domProps: {
                                          innerHTML: _vm._s(row.html)
                                        },
                                        slot: "content"
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "y-start" },
                                        _vm._l(row.ban_state, function(
                                          item,
                                          index
                                        ) {
                                          return _c("div", { key: index }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-ellipsis-1",
                                                staticStyle: { width: "380px" },
                                                style: {
                                                  color: item.finishs
                                                    ? "red"
                                                    : "goldenrod"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("operationTime")
                                                    ) +
                                                    ":" +
                                                    _vm._s(item.timenew) +
                                                    ", " +
                                                    _vm._s(
                                                      _vm.$t("banEndTime")
                                                    ) +
                                                    ":" +
                                                    _vm._s(
                                                      item.expire_timenew
                                                    ) +
                                                    ", " +
                                                    _vm._s(_vm.$t("reason")) +
                                                    _vm._s(item.reason) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ])
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _c("div", [_vm._v("/")])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3276040595
                )
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "abnormal_count",
                  label: _vm.$t("abnormalCount"),
                  "show-overflow-tooltip": "",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("operation"),
                  width: "160",
                  fixed: "right"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "x-c" }, [
                            row.op_type == 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "controlsBtn",
                                    on: {
                                      click: function($event) {
                                        {
                                          _vm.popData = row
                                          _vm.$refs.addEmperor.open(row, true)
                                        }
                                      }
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("punish")) + " ")]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "controlsBtn",
                                    on: {
                                      click: function($event) {
                                        {
                                          _vm.popData = row
                                          _vm.$refs.addEmperor.open(
                                            row,
                                            true,
                                            "up"
                                          )
                                        }
                                      }
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("modify")) + " ")]
                                ),
                            row.op_type == 1
                              ? _c("div", {
                                  staticClass: "controlsBtn-vertical"
                                })
                              : _vm._e(),
                            row.op_type == 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "controlsBtn",
                                    on: {
                                      click: function($event) {
                                        return _vm.deleHandle(row)
                                      }
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("unban")) + " ")]
                                )
                              : _vm._e()
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  135644598
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total,sizes, prev, pager, next",
              "current-page": _vm.paramsData.page,
              total: _vm.total
            },
            on: { "current-change": _vm.getList, "size-change": _vm.sizeChange }
          })
        : _vm._e(),
      _c("addEmperor", {
        ref: "addEmperor",
        attrs: {
          propsData: {
            server_id: _vm.popData.server_id,
            env_id: _vm.paramsData.env_id
          }
        },
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("add", {
        ref: "add",
        attrs: { propsData: { env_id: _vm.paramsData.env_id } },
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }